import { render, staticRenderFns } from "./LoginNews.vue?vue&type=template&id=23bd855e&"
import script from "./LoginNews.vue?vue&type=script&lang=js&"
export * from "./LoginNews.vue?vue&type=script&lang=js&"
import style0 from "./LoginNews.vue?vue&type=style&index=0&id=23bd855e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports